/**
 * Create Repayment Page
 */
import React from 'react';

const CreateRepayment = () => {
  return (
    <div>
      <h1 className="text-2xl font-bold text-gray-900 dark:text-white">Record Repayment</h1>
      <p className="text-gray-600 dark:text-gray-400 mt-2">Record a new loan repayment</p>
    </div>
  );
};

export default CreateRepayment;
